import { render, staticRenderFns } from "./playerTitle.vue?vue&type=template&id=54dbb3bd&scoped=true"
import script from "./playerTitle.vue?vue&type=script&lang=js"
export * from "./playerTitle.vue?vue&type=script&lang=js"
import style0 from "./playerTitle.vue?vue&type=style&index=0&id=54dbb3bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbb3bd",
  null
  
)

export default component.exports